interface useNewFormProps {
  categoriesIds: string[] | undefined;
}

const categoriesBooks = ['228310', '309573', '339770'];

const useCategoriesBooksFilter = ({ categoriesIds }: useNewFormProps) => {
  if (categoriesIds) {
    const withNewForm = categoriesBooks?.filter(str => categoriesIds?.some((id: string) => str === id));
    return withNewForm.length ? 'NEW' : 'OLD';
  }
  return undefined;
};

export default useCategoriesBooksFilter;
export { useCategoriesBooksFilter, categoriesBooks };
